import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import { colors } from 'styles/theme';
import { tabletUp, setOpacity, notLast, notFirst } from 'styles/utils';

import { articleShape } from 'components/InfoCenter/InfoCenter.config';

import Link from '../Link/Link';
import Text from '../Text/Text';

const listCss = css`
  grid-area: links;
`;

const listItemCss = css`
  ${notFirst} {
    padding-top: 25px;
  }

  ${notLast} {
    border-bottom: 1px solid ${setOpacity(colors.inputBorder, 0.4)};
    padding-bottom: 25px;
  }
`;

const articleLinkCss = css`
  color: ${colors.textColor};

  ${tabletUp} {
    display: inline-block;

    &:hover {
      color: ${colors.darkPurple};
    }
  }
`;

/**
 * A grid of article promos in a list layout.
 *
 * @param {Object} props
 */
function PromoListGrid({ articles }) {
  return (
    <ul css={listCss}>
      {articles.map(({ linkAs, linkHref, promoTitle, slug, title }) => (
        <li key={slug} css={listItemCss}>
          <Link href={linkHref} as={linkAs} css={articleLinkCss}>
            <Text fontSize={2.4} fontWeight={400}>
              {promoTitle ?? title}
            </Text>
          </Link>
        </li>
      ))}
    </ul>
  );
}

PromoListGrid.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.shape(articleShape)),
};

export default PromoListGrid;
